import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.isTag}}
  {{discourse-tag this.rowValue noHref=true count=this.item.count}}
{{else}}
  <span class="name">{{this.item.name}}</span>
{{/if}}
*/
{
  "id": "BoPdl8eH",
  "block": "[[[41,[30,0,[\"isTag\"]],[[[1,\"  \"],[1,[28,[35,1],[[30,0,[\"rowValue\"]]],[[\"noHref\",\"count\"],[true,[30,0,[\"item\",\"count\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,1],[14,0,\"name\"],[12],[1,[30,0,[\"item\",\"name\"]]],[13],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"discourse-tag\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/tag-row.hbs",
  "isStrictMode": false
});